export const CHAIN_ID_SEARCH_PARAM = 'chainId';
